<div class="loading" style="margin-top:15px;">
    <div class="cpanel">
        <div class="cpanel-header">
            <div class="row" *ngIf="!size.small">
                <div class="col-9">
                    <div class="cpanel-icon-div">
                        <i class="cpanel-icon fas fa-adjust"></i>
                    </div>
                    <div class="cpanel-title">&nbsp;&nbsp;|&nbsp;&nbsp; {{title}}</div>
                </div>
                <div class="col-3 text-right">
                    <button mat-raised-button class="cpanel-btn" (click)="service.infoDialog('f2', title)">Info</button>
                </div>
            </div>
            <table *ngIf="size.small">
                <tr>
                    <td class="pr10">
                        <i class="cpanel-icon fas fa-adjust"></i>
                    </td>
                    <td>
                        <div class="mobile-title">
                            {{title}} &nbsp; <a mat-button class="mobile-cpanel-info-btn c-light-blue" (click)="service.infoDialog('f2', title)">Info</a>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="cpanel-content">
          
            <form name="f2Form" (ngSubmit)="onSubmit()" [formGroup]="f2Form">

                <div class="row animate1 fadeIn" style="margin-bottom: 15px;">
                    <div class=" col-md-4">
                        <mat-form-field appearance="outline" class="wp100 bold">
                            <mat-label>Account Name</mat-label>
                            <input matInput placeholder="Account Name" formControlName="f2AccHolder" required>
                            <mat-error *ngIf="f.f2AccHolder.errors?.required && f.f2AccHolder.touched">Account Name is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="outline" class="wp100 bold">
                            <mat-label>BSB</mat-label>
                            <input matInput placeholder="BSB" formControlName="f2Bsb" name="f2Bsb" [dropSpecialCharacters]="true" mask="000-000" minlength="6">
                            <mat-error *ngIf="f.f2Bsb.errors?.minlength && f.f2Bsb.touched">BSB is invalid</mat-error>
                            <mat-error *ngIf="f.f2Bsb.errors?.required && f.f2Bsb.touched">BSB is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="outline" class="wp100 bold">
                            <mat-label>Account No</mat-label>
                            <input matInput placeholder="Account No." formControlName="f2Acc" name="f2Acc" mask="0*" required>
                            <mat-error *ngIf="f.f2Acc.errors?.required && f.f2Acc.touched">Account No is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>


                <div class="row" *ngIf="isFormChanged">
                    <div class="col-md-12 align-right">
                        <span *ngIf="f2Form.valid && isFormChanged" class="c-green bold">Press Continue button to Save Changes <i class="fas fa-arrow-circle-right fs12 c-dark-grey blink"></i></span>&nbsp;&nbsp;&nbsp;
                        <button mat-raised-button color="primary" class="sm30 c-white bold" type="submit" [disabled]="!f2Form.valid">Continue</button>
                    </div>
                </div>
            </form>
            <div class="row">
                <div class="col-md-12 fs16 text-center font-bold text-red-600">
                    <span>WARNING: Bank details MUST be under your name ONLY</span>
                </div>
            </div>
        </div>
    </div>
    <ngx-loading [show]="f2loading"></ngx-loading>
</div>